import { Check, Clock, UserPlus, Wallet } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const getStage = (user) => {
  if (user.status === "approved") return "active";
  if (user.status === "rejected") return "rejected";
  if (user.payment_receipt_path) return "pending";
  return "awaiting";
};

const STEPS = [
  { key: "step_registered", icon: UserPlus },
  { key: "step_payment", icon: Wallet },
  { key: "step_approved", icon: Check },
];

const reached = { awaiting: 1, rejected: 1, pending: 2, active: 3 };

export const StatusSteps = ({ stage }) => {
  const { t } = useLang();
  const done = reached[stage];
  return (
    <ol className="mt-8 grid grid-cols-3 gap-2 sm:gap-4" data-testid="dashboard-status-steps">
      {STEPS.map((s, i) => {
        const isDone = i < done;
        const isCurrent = i === done && stage !== "active";
        const Icon = isCurrent ? Clock : s.icon;
        return (
          <li key={s.key} data-testid={`status-step-${i}`} className={`flex flex-col items-start gap-2 rounded-2xl border p-3 sm:flex-row sm:items-center sm:p-4 ${isDone ? "border-primary/40 bg-primary/5" : "border-border bg-card"}`}>
            <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${isDone ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"}`}><Icon className="h-4 w-4" /></span>
            <span className={`text-xs font-bold sm:text-sm ${isDone ? "text-foreground" : "text-muted-foreground"}`}>{t(s.key)}</span>
          </li>
        );
      })}
    </ol>
  );
};
